import React from 'react';
import PropTypes from 'prop-types';

const FloatValidationLabel = ({ validationError }) =>
    (
        <div className='float-label-holder'>
            <span className='text-danger'>
                {validationError}
            </span>
        </div>
    );


FloatValidationLabel.propTypes = {
    validationError: PropTypes.string
};

export default FloatValidationLabel